import React, {useEffect, useState} from "react";
import {Stack, Typography} from "@mui/material";
import useCallDataApi from "../../hooks/data";
import ErrorHandlingForm from "../../components/formValidation/ErrorHandlingFrom";
import CustomTextField from "../../components/formValidation/CustomTextField";
import CustomControlledEditor from "../../components/formValidation/CustomControlledEditor";
import {validateEmail, validateRequired} from "../../components/formValidation/validators";

const EmailData = ({order, reference}) => {
    const {getData: fetchOrders} = useCallDataApi('orders');

    const [formState, setFormState] = useState({
        email: '',
        content: ''
    });

    const [errors, setErrors] = useState({
        email: false,
        content: false
    });

    const validators = {
        email: [validateRequired, validateEmail],
        content: [validateRequired]
    };

    useEffect(() => {
        if (order?.id) {
            fetchOrders(`${order.id}/manual_email_text`).then(r => {
                if (r?.text) {
                    setFormState(prev => ({
                        ...prev,
                        content: r?.text
                    }));
                }
                if (r?.email) {
                    setFormState(prev => ({
                        ...prev,
                        email: r.email
                    }));
                }
            });
        }
    }, [order?.id]);

    return (
        <ErrorHandlingForm 
            reference={reference} 
            errors={errors} 
            setErrors={setErrors} 
            data={formState} 
            setData={setFormState} 
            validators={validators}
        >
            <Stack spacing={2}>
                <Typography variant='h4' gutterBottom>Email cím:</Typography>
                <CustomTextField
                    data={formState}
                    setData={setFormState}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="email"
                />
                <Typography variant='h4' gutterBottom>Email szövege:</Typography>
                <CustomControlledEditor
                    data={formState}
                    setData={setFormState}
                    errors={errors}
                    setErrors={setErrors}
                    validators={validators}
                    name="content"
                />
            </Stack>
        </ErrorHandlingForm>
    );
};

export default EmailData; 